jQuery(document).ready(function($){
	if($('#commentform').length){
		$('#commentform').validate({

			rules:{
			  author:{
				required:true,
				minlength:2
			  },

			  email:{
				required:true,
				email:true
			  },

			  comment:{
				required:true,
				minlength:20
			  }
			},

			messages:{
			  author:"Please fill name field and minimum character limit is 2.",
			  email:"Please enter a valid email address.",
			  comment:"Please fill comment field and minimum character limit is 20."
			},

			errorElement:"div",
			errorPlacement:function(error,element){
			  element.after(error);
			}

		});
	}
});